import axios from 'axios';
import { Toast } from 'vant';
import store from '../store';

const request = axios.create({
  baseURL: '/api',
  timeout: 15000
});

request.interceptors.request.use(config => {
  const token = store.state.token;
  if (token) {
    config.headers.Authorization = 'Bearer ' + token;
  }
  return config;
}, error => Promise.reject(error));

request.interceptors.response.use(response => {
  const data = response.data;
  if (data.code !== 0) {
    Toast.fail(data.message || '请求失败');
    if (data.code === 1001) {
      store.dispatch('logout');
      window.location.hash = '#/login';
    }
    return Promise.reject(new Error(data.message));
  }
  return data;
}, error => {
  Toast.fail('网络错误，请稍后重试');
  return Promise.reject(error);
});

export default request;
